import Head from "next/head"
import React from "react"

import Breadcrumb from "~/components/organisms/Breadcrumb"
import Footer from "~/components/organisms/Footer"
import Header from "~/components/organisms/Header"
import { InfraEventPage } from "~/components/pages/InfraEventPage"
import { staticPath, internalLink } from "~/services/helper"

export default class Top extends React.Component {
  render() {
    const crumbs = [
      {
        name: "就活イベント",
        link: internalLink(`/events/infra-event`),
      },
    ]

    return (
      <>
        <Head>
          <title>Infra就活イベント - 在りたい自分を見つけ、キャリアを掴み取る | Infra（インフラ）</title>
          <meta
            name="description"
            content="Infraでは学生と企業を集めた少人数制の交流イベント「DRAFT」、実戦形式で各職種を体感できる「JOBS」、長期インターン経験などビジネス経験がある学生限定の「SCOUT」など様々な参加無料の就活イベントを開催しています。"
          />
          <meta
            property="og:title"
            content="Infra就活イベント - 在りたい自分を見つけ、キャリアを掴み取る | Infra（インフラ）"
          />
          <meta
            property="og:description"
            content="Infraでは学生と企業を集めた少人数制の交流イベント「DRAFT」、実戦形式で各職種を体感できる「JOBS」、長期インターン経験などビジネス経験がある学生限定の「SCOUT」など様々な参加無料の就活イベントを開催しています。"
          />
          <meta property="og:image" content={`${process.env.APP_HOST + staticPath("/static/images/ogp.png")}`} />
        </Head>
        <Header showTab selectedTab="Event" logoType="Plain" />

        <InfraEventPage />

        <Breadcrumb crumbs={crumbs} />
        <Footer />
      </>
    )
  }
}
